import { ICypressProps } from 'interfaces/ICypressProps';
import { ReactElement } from 'react';
import styled from 'styled-components';
import { link } from 'styles/theme';

export interface IExternalLinkProps extends ICypressProps {
    url: string;
    children: ReactElement | string;
    className?: string;
}

const Link = styled.a`
    color: ${link};
`;

export function ExternalLink(props: IExternalLinkProps) {
    const { url, children, className, 'data-cy': cypressSelector } = props;

    return (
        <Link
            data-cy={cypressSelector}
            className={['external-link', className].join(' ')}
            target="_blank"
            rel="noopener noreferrer"
            href={url}
        >
            {children}
        </Link>
    );
}
